





























import Vue from 'vue'

export default Vue.extend({
  name: "HeroSliderLink",

  props: {
    title: {
      type: String,
      default: () => ''
    },

    link: {
      type: String,
      default: () => ''
    },

    external: {
      type: Boolean,
      default: () => false
    },

    index: {
      type: Number,
      default: () => 0
    }
  },

  computed: {
    buttonClass(): string {
      return this.index === 0
        ? 'hero-slider__button-primary'
        : 'hero-slider__button-secondary'
    }
  }
})
